export default "__VITE_ASSET__Cy85SNK5__"